module.exports = __webpack_public_path__ + "media/images/cueva-f971433ecd3e6924074ef338bc9487c2.jpg";